export interface User {
  country: string;
  created: number;
  dateFormat: ValidDateFormats;
  email: string;
  firstName: string;
  id: string;
  lastName: string;
  timeFormat: ValidTimeFormats;
  language: string;
  uom: UOM;
  system: {
    [message: string]: number;
  };
  roles: UserRole[];
}

// csdp-api/internal/models/user.go
export enum UserRole {
  SYSTEM_ADMIN = '1',
  CLINICAL_ADMIN = '2',
}
